module.exports = __webpack_public_path__ + "static/media/nursingliquid2.b8cee83e.jpg";